import domContentLoaded from 'utils/domContentLoaded';

function initPinkScriptsTracking(pink) {
  
      pink.addEventListener('click', function () {
        console.log("CTA3.1 pink pdf click", this);
        
        const s3_event = S3Helper.getEvent('Addyi.pink_pdf');
        
        s3_event.wv_element_children = this.dataset.downloadLabel;
        s3_event.wv_element = this.dataset.pinkScript;
        
        window.S3Helper.pushToS3(s3_event, true);
        
    }); 
 }
 
 
domContentLoaded(() => {

  document.querySelectorAll('.js-pink-script-link').forEach((root) => {
       initPinkScriptsTracking(root); 
  });

});
 